var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-popover",
    { attrs: { placement: "right", width: "400", trigger: "hover" } },
    [
      _c("iframe-loader", { attrs: { url: _vm.getPreviewUrl } }),
      _vm._v(" "),
      _c("a", {
        staticClass: "cursor-pointer",
        attrs: { slot: "reference" },
        domProps: { textContent: _vm._s(_vm.shortBody) },
        slot: "reference",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }